module.exports = __webpack_public_path__ + "static/cnc-processing-1eb2946f3cf6ba4efb78804faec46ab1.png";